import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueBus from 'vue-bus';
import VueCarousel from 'vue-carousel';
import Meta from 'vue-meta';
import VueGtm from 'vue-gtm';

Vue.use(Meta);
Vue.use(VueCarousel);
Vue.use(VueBus);
Vue.use(VueGtm, {
    id: 'GTM-PLJRMVW',
    defer: true,
    enabled: true,
    debug: true,
    loadScript: true,
    vueRouter: router,
    trackOnNextTick: true,
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
